import { createFileRoute } from "@tanstack/react-router"

import PerformanceTab from "~/components/demand-2/tabs/PerformanceTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand/_layout/performance")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Demand - Performance")
  return <PerformanceTab />
}
